'use es6';

import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import FeedbackLoader from 'feedback-loader';
import AnalyticsSuite from './analyticsSuites/AnalyticsSuite';
import AnalyticsSubSuite from './analyticsSuites/AnalyticsSubSuite';
import { getAllCategoryReports, getAllCollectionReports, getAnalyticsToolsIA } from '../config/analyticTools';
import { getGatesAndScopes } from '../selectors/gatesSelector';
import { fetchReportCollectionTemplates } from '../redux/reportCollectionTemplates';
import { findParentNavItem } from './TemplatesSideBar';
import AnalyticsSuitesBreadCrumbs from '../components/common/AnalyticsSuitesBreadCrumbs';
import { trackEvent, EVENTS } from '../lib/usageTracker';
import AnalyticsAccessWrapper from './AnalyticsAccessWrapper';
import useCommerceCRMRecordReportZeroState from '../hooks/useCommerceCRMRecordReportZeroState';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ReportCollectionHomesContainer = () => {
  const {
    collectionId,
    categoryId
  } = useParams();
  const [feedbackClient, setFeedbackClient] = useState();
  const dispatch = useDispatch();
  const showSampleCommerceZeroState = useCommerceCRMRecordReportZeroState(categoryId);
  const {
    gates,
    scopes
  } = useSelector(getGatesAndScopes);
  const collectionIA = getAnalyticsToolsIA(gates, scopes).find(collection => collection.get('id') === collectionId);
  const allReports = categoryId ? getAllCategoryReports(findParentNavItem(collectionIA.get('children'), categoryId), gates, scopes) : getAllCollectionReports(collectionId, gates, scopes);
  useEffect(() => {
    dispatch(fetchReportCollectionTemplates());
  }, [dispatch]);
  useEffect(() => {
    // match naming of report page view tracking
    const screen = `${collectionId}-analytics`;
    const subscreen = categoryId ? `${categoryId}-category-home` : `${collectionId}-home`;
    const whichStage = categoryId ? 'category-home' : 'analytics-home';
    trackEvent(EVENTS.pageView, {
      screen,
      subscreen,
      whichStage
    });
  }, [collectionId, categoryId]);
  return (
    /*#__PURE__*/
    // this page uses a "compact" layout so the content area only has left side padding -- see CustomListingPageWrapper.js
    _jsx("div", {
      "data-test-id": "report-collection-homes-container",
      children: /*#__PURE__*/_jsxs(AnalyticsAccessWrapper, {
        children: [/*#__PURE__*/_jsx(AnalyticsSuitesBreadCrumbs, {
          collectionId: collectionId,
          categoryId: categoryId
        }), /*#__PURE__*/_jsx(FeedbackLoader, {
          onClientLoad: client => {
            setFeedbackClient(client);
          }
        }), categoryId ? /*#__PURE__*/_jsx(AnalyticsSubSuite, {
          categoryId: categoryId,
          reports: allReports,
          feedbackClient: feedbackClient,
          showSampleZeroState: showSampleCommerceZeroState
        }) : /*#__PURE__*/_jsx(AnalyticsSuite, {
          collectionId: collectionId,
          reports: allReports,
          feedbackClient: feedbackClient
        })]
      })
    })
  );
};
export default ReportCollectionHomesContainer;